function convertHtmlToMarkdown(element: Element, fallbackText: string): string {
  let markdown = '';

  for (const node of element.childNodes) {
    if (node.nodeType === Node.TEXT_NODE) {
      markdown += node.textContent || '';
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as Element;
      const tagName = el.tagName.toLowerCase();

      switch (tagName) {
        case 'strong':
        case 'b':
          markdown += `**${convertHtmlToMarkdown(el, '')}**`;
          break;
        case 'em':
        case 'i':
          markdown += `*${convertHtmlToMarkdown(el, '')}*`;
          break;
        case 'code':
          if (el.parentElement?.tagName.toLowerCase() === 'pre') {
            // Code block
            markdown += `\`\`\`\n${el.textContent}\n\`\`\``;
          } else {
            // Inline code
            markdown += `\`${el.textContent}\``;
          }
          break;
        case 'ul':
          markdown += convertListToMarkdown(el, false);
          break;
        case 'ol':
          markdown += convertListToMarkdown(el, true);
          break;
        case 'p': {
          const pContent = convertHtmlToMarkdown(el, '');
          if (pContent.trim()) {
            markdown += pContent + '\n\n';
          }
          break;
        }
        case 'br':
          markdown += '\n';
          break;
        case 'a': {
          const href = el.getAttribute('href');
          const text = el.textContent || '';
          if (href) {
            markdown += `[${text}](${href})`;
          } else {
            markdown += text;
          }
          break;
        }
        case 'h1':
          markdown += `# ${convertHtmlToMarkdown(el, '')}\n\n`;
          break;
        case 'h2':
          markdown += `## ${convertHtmlToMarkdown(el, '')}\n\n`;
          break;
        case 'h3':
          markdown += `### ${convertHtmlToMarkdown(el, '')}\n\n`;
          break;
        default:
          markdown += convertHtmlToMarkdown(el, '');
          break;
      }
    }
  }
  return markdown.trim() || fallbackText;
}

function convertListToMarkdown(
  listElement: Element,
  isOrdered: boolean
): string {
  let markdown = '';
  const items = listElement.children;

  for (let i = 0; i < items.length; i++) {
    const li = items[i];
    if (li.tagName.toLowerCase() === 'li') {
      const prefix = isOrdered ? `${i + 1}. ` : '- ';
      const content = convertHtmlToMarkdown(li, '');
      markdown += `${prefix}${content}\n`;
    }
  }

  return markdown + '\n';
}

export function convertSelectionToMarkdown(
  range: Range,
  selectedText: string
): string {
  try {
    const container = document.createElement('div');
    container.appendChild(range.cloneContents());

    return convertHtmlToMarkdown(container, selectedText);
  } catch (error) {
    console.warn('Failed to convert selection to markdown:', error);
    return selectedText;
  }
}

export function getSelectionMarkdown(
  range: Range,
  selectedText: string
): string {
  try {
    let messageElement = range.commonAncestorContainer;
    while (messageElement && messageElement.nodeType !== Node.ELEMENT_NODE) {
      messageElement = messageElement.parentNode as Node;
    }

    while (
      messageElement &&
      !(messageElement as Element).hasAttribute('data-message-id')
    ) {
      messageElement = messageElement.parentElement as Node;
    }

    if (!messageElement) {
      console.warn('Could not find message container for selection');
      return selectedText;
    }

    return convertSelectionToMarkdown(range, selectedText);
  } catch (error) {
    console.warn('Failed to extract markdown from selection:', error);
    return selectedText;
  }
}
